import React from "react";
import TranslationKeys from "../../../../contexts/I18nContext/translationKeys";
import { Translate, TranslateHtml } from "../../../Translation/Translate";
import {
  InvestmentProfileDto,
  SuitabilityStatus,
  SuitabilityStatuses,
} from "../../../../data/dtos/investment-profile.dto";
import { SuitabilityButton } from "./SuitabilityButton";
import { WhmChip } from "@securitize/reactjs-whm";
import { InfoCard } from "../../shared/InfoCard";

const chipStatusColorMap = {
  [SuitabilityStatuses.PROCESSING]: "warning",
  [SuitabilityStatuses.VERIFIED]: "success",
  [SuitabilityStatuses.NOT_APPROVED]: "error",
  [SuitabilityStatuses.NONE]: "success",
} as const;

const chipStatusTextMap = {
  [SuitabilityStatuses.PROCESSING]:
    TranslationKeys.INVESTMENT_PROFILE_STATUS_IN_REVIEW,
  [SuitabilityStatuses.VERIFIED]:
    TranslationKeys.INVESTMENT_PROFILE_STATUS_COMPLETED,
  [SuitabilityStatuses.NOT_APPROVED]:
    TranslationKeys.INVESTMENT_PROFILE_STATUS_REJECTED,
  [SuitabilityStatuses.NONE]:
    TranslationKeys.INVESTMENT_PROFILE_STATUS_COMPLETED,
} as const;

const SuitabilityChip = ({ status }: { status: SuitabilityStatus }) => {
  return (
    <WhmChip
      variant="filled"
      label={<Translate translationKey={chipStatusTextMap[status]} />}
      color={chipStatusColorMap[status]}
      sx={{ marginTop: "12px" }}
    />
  );
};

interface SuitabilityCardProps {
  investmentProfileData: InvestmentProfileDto;
  currentPath: string;
}

export const SuitabilityCard: React.FC<SuitabilityCardProps> = ({
  investmentProfileData,
  currentPath,
}) => {
  return (
    <InfoCard
      title={
        <Translate
          translationKey={TranslationKeys.PROFILE_INVESTMENT_PROFILE_CARD_TITLE}
        />
      }
      subtitle={
        <TranslateHtml
          translationKey={
            TranslationKeys.PROFILE_INVESTMENT_PROFILE_CARD_SUBTITLE
          }
        />
      }
      smallPadding
    >
      {investmentProfileData.suitabilityStatus === SuitabilityStatuses.NONE ? (
        <SuitabilityButton currentPath={currentPath} />
      ) : (
        <SuitabilityChip status={investmentProfileData.suitabilityStatus} />
      )}
    </InfoCard>
  );
};
